import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVertical, PlusSquare, Share2, Trash2, Box } from "lucide-react";
import { TeamIcon } from "@/components/icons/TeamIcon";
import { ContentItem } from "@/types/content";
import { Room } from "@/types/rooms";

export const ContentActionsMenu = ({
  item,
  rooms,
  onAddToRoom,
  onShare,
  onDelete,
  variant = "card",
}: {
  item: ContentItem;
  rooms?: Room[];
  onAddToRoom?: (item: ContentItem, roomId: string) => void;
  onShare?: (item: ContentItem) => void;
  onDelete?: (item: ContentItem) => void;
  variant?: "card" | "list";
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={
            variant === "list"
              ? "inline-flex h-8 w-8 items-center justify-center rounded-full p-1.5 transition-colors hover:bg-muted"
              : "absolute right-2.5 top-2.5 z-30 rounded-full p-1 group-hover:bg-background/60 dark:group-hover:bg-primary/40 transition"
          }
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4 text-muted-foreground hover:text-foreground" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44">
        {/* Add to Room - Nested Menu */}
        <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center gap-2">
            <PlusSquare className="h-4 w-4" />
            Add to Room
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="w-48 max-h-48 overflow-y-auto">
            {rooms && rooms.length > 0 ? (
              rooms.map((room) => (
                <DropdownMenuItem
                  key={room.id}
                  onClick={() => onAddToRoom?.(item, room.id)}
                >
                  {room.team_id ? <TeamIcon className="h-4 w-4 mr-2" size={16} /> : <Box className="h-4 w-4 mr-2" />}
                  <span className="truncate max-w-[120px]">{room.name}</span>
                </DropdownMenuItem>
              ))
            ) : (
              <DropdownMenuItem disabled>
                No rooms available
              </DropdownMenuItem>
            )}
          </DropdownMenuSubContent>
        </DropdownMenuSub>

        <DropdownMenuSeparator />

        <DropdownMenuItem 
          className="flex items-center gap-2"
          onClick={() => onShare?.(item)}
        >
          <Share2 className="h-4 w-4" /> Share
        </DropdownMenuItem>

        <DropdownMenuItem
          className="flex items-center gap-2 text-destructive focus:bg-destructive/10 focus:text-destructive"
          onClick={() => onDelete?.(item)}
        >
          <Trash2 className="h-4 w-4" /> Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
